<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filterInspection" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Inspection Id</mat-label>
          <input placeholder="Inspection Id"
            matInput
            [matChipInputFor]="chipInspectionId"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'inspectionids')">
          </mat-form-field>
          <mat-chip-grid #chipInspectionId>
            @for (item of inspectionIds; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'inspectionids')">
                {{item}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>
        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Unit Id</mat-label>
            <input placeholder="Unit Id"
              matInput
              [matChipInputFor]="chipUnitId"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'unitids')">
            </mat-form-field>
            <mat-chip-grid #chipUnitId>
              @for (item of unitIds; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'unitids')">
                  {{item}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>
          <div class="filter-actions">
            <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
              {{ changeTypeButton() ? 'Reset' : 'Filter' }}
            </button>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
